import SparkMD5 from 'spark-md5';
import type JSZip from 'jszip';

// Design intent: these packers reproduce prismaTS's SD-card export closely enough
// that both SignalViewer AND prismaTS can open the result. The entry layout carries
// the signals/events/therapy settings SignalViewer reads; the pTS-only artifacts it
// ignores — P5 & P3.2 `Hash.txt`, P3.2's root `statistic.proto` — are the
// detection/dedup files prismaTS's *ContainerFileImporter requires, regenerated here
// exactly as pTS's own importer derives them. P2.8's `statistic.psstat` is
// device-written data we can only pass through (pack-p28 warns when it's absent).

export type PackProgress = (percent: number) => void;

// base64(MD5(bytes)) — the value prismaTS writes into Hash.txt and uses as an
// import's dedup key (P5FileSystemImporter.GetHash / P32ImportFileDto.GetImportHash,
// both `Convert.ToBase64String(md5)`). Matched byte-for-byte so a prismaTS re-import
// dedups against a real device import instead of forking a duplicate.
export const md5Base64 = (data: ArrayBuffer): string =>
  btoa(SparkMD5.ArrayBuffer.hash(data, true));

const GENERATE_OPTIONS: JSZip.JSZipGeneratorOptions<'blob'> = {
  type: 'blob',
  compression: 'DEFLATE',
  compressionOptions: { level: 6 },
};

export const finalize = (
  zip: JSZip,
  onProgress?: PackProgress,
): Promise<Blob> =>
  zip.generateAsync(GENERATE_OPTIONS, (meta) => onProgress?.(meta.percent));
